module.exports = __webpack_public_path__ + "img/15.10d5bbb8.png";